var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 20V10.85C2.15 10.6167 1.43733 10.15 0.862001 9.45C0.286668 8.75 -0.000665509 7.93333 1.15741e-06 7V6.8306e-07H2V7H3V6.8306e-07H5V7H6V6.8306e-07H8V7C8 7.93333 7.71233 8.75 7.137 9.45C6.56167 10.15 5.84933 10.6167 5 10.85V20H3ZM13 20V12H10V5C10 3.61667 10.4877 2.43733 11.463 1.462C12.4383 0.486667 13.6173 -0.000665984 15 6.8306e-07V20H13Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkWhite);
export default __webpack_public_path__ + "static/media/fork_white.44f40b3a8beeb389641b2b24955a44a7.svg";
export { ForwardRef as ReactComponent };